import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { runBeforeAddInbox } from 'pages/settings/lib/runBeforeAddInbox'
import { runBeforeAddMember } from 'pages/settings/lib/runBeforeAddMember'

export class MembersStore {
  constructor(private _entities: IEntitiesStore) {
    this._initInboxes()

    makeAutoObservable(this)
  }

  private _initInboxes() {
    this._entities.inboxesStore.loadOrganizationInboxes()
  }

  manageMemberWrapper = (onSuccess: () => void, options?: { skipCanceledCheck?: boolean }) => {
    runBeforeAddMember(this._entities, onSuccess, {
      checkCanceled: !options?.skipCanceledCheck,
    })
  }

  manageInboxWrapper = (onSuccess: () => void) => {
    runBeforeAddInbox(this._entities, onSuccess)
  }
}
